'use client';

import { IResolvedContactForm } from '@/src/utils/collections/contact-form.mapper';
import { Button } from '@/src/components/ui/button';
import { useContactForm } from '@/src/components/contact-form/useContactForm';
import { ContactFormEmail } from '@/src/components/contact-form/ContactFormEmail';
import { ContactFormMessage } from '@/src/components/contact-form/ContactFormMessage';
import { ContactFormCheckbox } from '@/src/components/contact-form/ContactFormCheckbox';
import { IResolvedErrors } from '@/src/utils/collections/errors.mapper';

interface IProps extends IResolvedContactForm {
  errorTexts?: IResolvedErrors | null;
}

const ContactForm = ({
  title,
  subTitle,
  labelInputEmail,
  labelInputMessage,
  checkbox,
  button,
  errorTexts,
}: IProps) => {
  const { register, handleSendEmail, errors, isValid } = useContactForm();
  return (
    <div className="relative inset-x-1/2 -mx-[50vw] my-12 w-screen bg-overlay px-4 py-10 lg:py-30">
      <div className={'mx-auto max-w-840 space-y-10'}>
        <h4 className={'text-4xl font-semibold text-primary'}>{title}</h4>
        {subTitle && <p className={'text-xl font-semibold'}>{subTitle}</p>}
        <ContactFormEmail
          label={labelInputEmail}
          errors={errors?.email?.message}
          register={register}
          errorTexts={errorTexts}
        />
        <ContactFormMessage
          label={labelInputMessage}
          errors={errors?.message?.message}
          register={register}
          errorTexts={errorTexts}
        />
        <ContactFormCheckbox
          label={checkbox}
          errors={errors?.cgu?.message}
          register={register}
          errorTexts={errorTexts}
        />
        <div className={'flex justify-center'}>
          <Button
            size={'md'}
            className={' active:bg-primary-dark'}
            onClick={handleSendEmail}
            disabled={!isValid}
          >
            {button}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
